"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackServiceImpl = void 0;
var FeedbackProviderImpl_1 = require("./provider/firebase/FeedbackProviderImpl");
var FeedbackProviderImpl_2 = require("./provider/airabbi/FeedbackProviderImpl");
var FeedbackServiceImpl = (function () {
    function FeedbackServiceImpl(cfg) {
        this.cfg = cfg;
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new FeedbackProviderImpl_1.FeedbackProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new FeedbackProviderImpl_2.FeedbackProviderImpl(cfg);
                break;
        }
    }
    FeedbackServiceImpl.prototype.init = function (env, cfg) {
        return this.provider.init(env);
    };
    FeedbackServiceImpl.prototype.setDebuggable = function (debuggable) {
        return this.provider.setDebuggable(debuggable);
    };
    FeedbackServiceImpl.prototype.createFeedback = function (uid, title, content, screenshotUrl, ccList) {
        return this.provider.createFeedback(uid, title, content, screenshotUrl, ccList);
    };
    FeedbackServiceImpl.prototype.getFeedback = function (id) {
        return this.provider.getFeedback(id);
    };
    FeedbackServiceImpl.prototype.getFeedbacks = function (uid) {
        return this.provider.getFeedbacks(uid);
    };
    FeedbackServiceImpl.prototype.removeFeedback = function (id) {
        return this.provider.removeFeedback(id);
    };
    FeedbackServiceImpl.prototype.updateFeedback = function (id, feedback) {
        return this.provider.updateFeedback(id, feedback);
    };
    FeedbackServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    return FeedbackServiceImpl;
}());
exports.FeedbackServiceImpl = FeedbackServiceImpl;
//# sourceMappingURL=FeedbackServiceImpl.js.map